(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-study"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('case-study')) {
    class CaseStudy extends HTMLElement {
      elements;
      slider;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;
      }
  
      initSlider = () => {
        const sid = this.sid;

        this.slider = new Swiper(`#shopify-section-${this.sid} [data-case-study-slider].swiper`, {
          a11y: true,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoheight: false,
          freeMode: true,
          navigation: {
            enabled: true,
            nextEl: `#shopify-section-${this.sid} .swiper-button-next`,
            prevEl: `#shopify-section-${this.sid} .swiper-button-prev`,
          },
          on: {
            init: function () {
              const slider_element = document.querySelector(`#shopify-section-${sid} [data-case-study-slider].swiper`);
              const total_slides = Number(slider_element.dataset.totalSlides);
              const current_index = this.realIndex;
              const previous_index = (this.realIndex === 0) ? (total_slides - 1) : this.realIndex - 1;
              const next_index = (this.realIndex + 1 > total_slides - 1) ? 0 : this.realIndex + 1;

              slider_element.parentElement.querySelector('.swiper-button-prev [data-title]').innerHTML = slider_element.querySelector(`[data-swiper-slide-index="${previous_index}"]`).dataset.slideTitle;
              slider_element.parentElement.querySelector('.swiper-button-next [data-title]').innerHTML = slider_element.querySelector(`[data-swiper-slide-index="${next_index}"]`).dataset.slideTitle;
            },
            slideChangeTransitionStart: function () {
              const slider_element = document.querySelector(`#shopify-section-${sid} [data-case-study-slider].swiper`);
              const total_slides = Number(slider_element.dataset.totalSlides);
              const current_index = this.realIndex;
              const previous_index = (this.realIndex === 0) ? (total_slides - 1) : this.realIndex - 1;
              const next_index = (this.realIndex + 1 > total_slides - 1) ? 0 : this.realIndex + 1;

              slider_element.parentElement.querySelector('.swiper-button-prev [data-title]').innerHTML = slider_element.querySelector(`[data-swiper-slide-index="${previous_index}"]`).dataset.slideTitle;
              slider_element.parentElement.querySelector('.swiper-button-next [data-title]').innerHTML = slider_element.querySelector(`[data-swiper-slide-index="${next_index}"]`).dataset.slideTitle;
            },
          }
        });
      };
    }

    customElements.define('case-study', CaseStudy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('content-slider')) {
    class ContentSlider extends HTMLElement {
      elements;
      slider;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-content-slider].swiper`),
        };
      }
  
      initSlider = () => {
        this.slider = new Swiper(`#shopify-section-${this.sid} [data-content-slider].swiper`, {
          a11y: true,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoheight: false,
          freeMode: false,
          autoplay: {
            delay: 50000,
          },
          pagination: {
            el: `#shopify-section-${this.sid} .swiper-pagination`,
            clickable: true,
          },
        });
      };
    }

    customElements.define('content-slider', ContentSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-study"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-study')) {
    class FeaturedStudy extends HTMLElement {
      elements;
      slider;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-featured-study-slider].swiper`),
        };
      }
  
      initSlider = () => {
        this.slider = new Swiper(`#shopify-section-${this.sid} [data-featured-study-slider].swiper`, {
          a11y: true,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoheight: false,
          freeMode: true,
          pagination: {
            el: `#shopify-section-${this.sid} .swiper-pagination`,
            clickable: true,
          },
          breakpoints: {
            990: {
              navigation: {
                enabled: true,
                nextEl: `#shopify-section-${this.sid} .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .swiper-button-prev`,
              },
            }
          }
        });
      };
    }

    customElements.define('featured-study', FeaturedStudy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-bundle-ingredients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haroutine-bundle-ingredients')) {
  customElements.define('haroutine-bundle-ingredients', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.ready) return;
      this.tabs = Array.from(this.querySelectorAll('[data-product-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-product-panel]'));
      this.tabList = this.querySelector('[data-tabs]');
      if (!this.tabList || this.tabs.length !== 2 || this.panels.length !== 2) return;
      this.ready = true;
      this.activeKey = this.activeKey || this.dataset.initialProduct || 'am';
      this.breakpoint = window.matchMedia('(max-width: 749px)');
      this.panels.forEach(panel => {
        const button = panel.querySelector('[data-more]');
        if (button) {
          button.hidden = false;
          this.setExpanded(panel, button.getAttribute('aria-expanded') === 'true');
        }
      });
      this.onChange = () => this.applyLayout();
      this.onClick = event => {
        const tab = event.target.closest('[data-product-tab]');
        if (tab && this.contains(tab)) {
          this.activeKey = tab.dataset.productTab;
          this.applyLayout();
        }
        const more = event.target.closest('[data-more]');
        if (more && this.contains(more)) this.setExpanded(more.closest('[data-product-panel]'), more.getAttribute('aria-expanded') !== 'true');
      };
      this.onKeydown = event => {
        const tab = event.target.closest('[data-product-tab]');
        if (!tab || !this.tabs.includes(tab) || !this.breakpoint.matches) return;
        let next;
        if (event.key === 'ArrowRight') next = this.tabs[(this.tabs.indexOf(tab) + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') next = this.tabs[(this.tabs.indexOf(tab) + this.tabs.length - 1) % this.tabs.length];
        if (event.key === 'Home') next = this.tabs[0];
        if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (next) {
          event.preventDefault();
          this.activeKey = next.dataset.productTab;
          this.applyLayout();
          next.focus();
        }
      };
      this.onToggle = event => {
        const detail = event.target;
        if (this.dataset.singleOpen !== 'true' || !detail.matches('[data-ingredient]') || !detail.open) return;
        detail.closest('[data-product-panel]').querySelectorAll('[data-ingredient][open]').forEach(other => { if (other !== detail) other.open = false; });
      };
      this.onBlockSelect = event => {
        const eventSection = event.detail && event.detail.sectionId;
        if (eventSection && eventSection !== this.dataset.sectionId) return;
        const id = event.detail && event.detail.blockId;
        const item = Array.from(this.querySelectorAll('[data-block-id]')).find(block => block.dataset.blockId === id);
        if (!item) return;
        const panel = item.closest('[data-product-panel]');
        this.activeKey = panel.dataset.productPanel;
        this.applyLayout();
        if (item.closest('[data-extra]')) this.setExpanded(panel, true);
        item.open = true;
        if (item.scrollIntoView) item.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('toggle', this.onToggle, true);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      if (this.breakpoint.addEventListener) this.breakpoint.addEventListener('change', this.onChange);
      else this.breakpoint.addListener(this.onChange);
      this.applyLayout();
    }
    setExpanded(panel, expanded) {
      const extra = panel.querySelector('[data-extra]');
      const button = panel.querySelector('[data-more]');
      if (!extra || !button) return;
      extra.hidden = !expanded;
      button.setAttribute('aria-expanded', String(expanded));
      button.querySelector('[data-more-label]').textContent = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
    }
    applyLayout() {
      const mobile = this.breakpoint.matches;
      this.tabList.hidden = !mobile;
      this.tabs.forEach(tab => {
        const selected = tab.dataset.productTab === this.activeKey;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const key = panel.dataset.productPanel;
        const tab = this.tabs.find(button => button.dataset.productTab === key);
        panel.hidden = mobile && key !== this.activeKey;
        panel.setAttribute('role', mobile ? 'tabpanel' : 'region');
        panel.setAttribute('aria-labelledby', mobile ? tab.id : panel.querySelector('.hbi-product-title').id);
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (!this.ready) return;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('toggle', this.onToggle, true);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.breakpoint.removeEventListener) this.breakpoint.removeEventListener('change', this.onChange);
      else this.breakpoint.removeListener(this.onChange);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-ingredient-explorer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'haroutine-ingredient-explorer';
    if (!('customElements' in window) || customElements.get(elementName)) return;

    class HaroutineIngredientExplorer extends HTMLElement {
      constructor() {
        super();
        this.handleToggle = this.handleToggle.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
      }

      connectedCallback() {
        this.addEventListener('toggle', this.handleToggle, true);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.handleToggle, true);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      closeOthers(current) {
        if (this.dataset.singleOpen !== 'true') return;
        this.querySelectorAll('details.hi-item[open]').forEach((item) => {
          if (item !== current) item.open = false;
        });
      }

      handleToggle(event) {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !item.matches('.hi-item') || !item.open) return;
        this.closeOthers(item);
      }

      handleBlockSelect(event) {
        const blockId = event.detail && event.detail.blockId;
        const item = Array.from(this.querySelectorAll('details.hi-item')).find((node) => node.dataset.blockId === blockId);
        if (!item) return;
        this.closeOthers(item);
        item.open = true;
      }
    }

    customElements.define(elementName, HaroutineIngredientExplorer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-liposomal-proof"] && !Shopify.designMode) return;
  try {
    
  if ('customElements' in window && !customElements.get('haroutine-liposomal-section')) {
    customElements.define('haroutine-liposomal-section', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.setupVideo());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.observer) this.observer.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
        if (this.video && this.onInteraction) {
          this.video.removeEventListener('pointerdown', this.onInteraction);
          this.video.removeEventListener('keydown', this.onInteraction);
        }
        if (this.video && this.autoPlaying) this.video.pause();
        this.autoPlaying = false;
      }
      setupVideo() {
        this.video = this.querySelector('video');
        if (!this.video || this.dataset.autoplay !== 'true' || this.dataset.designMode === 'true') return;
        // Without these browser features, native click-to-play remains available.
        if (!('IntersectionObserver' in window) || !window.matchMedia) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.userInteracted = false;
        this.autoPlaying = false;
        this.onInteraction = () => { this.userInteracted = true; this.autoPlaying = false; };
        this.onVisibility = () => this.syncPlayback();
        this.onMotion = () => this.syncPlayback();
        this.video.addEventListener('pointerdown', this.onInteraction);
        this.video.addEventListener('keydown', this.onInteraction);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onMotion);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .25);
          this.syncPlayback();
        }, { threshold: [0, .25] });
        this.observer.observe(this.video);
      }
      syncPlayback() {
        if (!this.isConnected || this.userInteracted || !this.video) return;
        const canPlay = this.inView && !this.motion.matches && document.visibilityState !== 'hidden';
        if (canPlay && !this.autoPlaying) {
          this.video.muted = true;
          this.video.defaultMuted = true;
          this.autoPlaying = true;
          const attempt = this.video.play();
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => { this.autoPlaying = false; });
          }
        } else if (!canPlay && this.autoPlaying) {
          this.video.pause();
          this.autoPlaying = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.querySelector('.announcement-bar-section').classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.querySelector('.announcement-bar-section').classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.querySelector('.announcement-bar-section').classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Open on hover
  // https://community.shopify.com/c/shopify-design/open-drop-down-to-mega-menu-on-hover-in-dawn-theme/td-p/1754347
  let items = document.querySelectorAll('.mega-menu');
  let header = document.querySelector('header');
  let currentItemIndex;
  
  items.forEach((item, itemIndex) => {
    const content = item.querySelector('.mega-menu__content')
    item.addEventListener('mouseover', () => {
      if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex && currentItemIndex !== itemIndex)
      ) {
        items[currentItemIndex].removeAttribute('open');
        document.body.classList.remove('megamenu-open');
      }

      currentItemIndex = itemIndex;
      item.setAttribute('open', true);
      document.body.classList.add('megamenu-open');
    });

    item.addEventListener('mouseleave', (event) => {
      /*
      let close = true;

      const closeTimeout = setTimeout(() => {
        if (close) {
          item.removeAttribute('open');
          document.body.classList.remove('megamenu-open');
        }
      }, 200);
      
      content.addEventListener('mouseover', () => {
        close = false;
      });

      item.addEventListener('mouseover', () => {
        clearTimeout(closeTimeout);
      });
      */
      item.removeAttribute('open');
      document.body.classList.remove('megamenu-open');
    });

    content.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
      document.body.classList.remove('megamenu-open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inner-beauty"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inner-beauty')) {
    class InnerBeauty extends HTMLElement {
      elements;
      list_collection;
      slider;
      thumbs;
      selected_group;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-inner-beauty-slider].swiper`),
          thumbs: document.querySelector(`#shopify-section-${this.sid} [data-inner-beauty-slider-thumbs].swiper`),
        };
      }

      initSlider = () => {
        if (!this.elements.slider) {
          return;
        }

        const main_slider_settings = {
          a11y: true,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoheight: false,
          freeMode: false,
          autoplay: {
            delay: 50000,
          },
          pagination: {
            el: `#shopify-section-${this.sid} .swiper-pagination`,
            clickable: true,
          },
        };

        if (this.elements.thumbs) {
          this.thumbs = new Swiper(`#shopify-section-${this.sid} [data-inner-beauty-slider-thumbs].swiper`, {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 3,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
              990: {
                spaceBetween: 20,
                direction: 'vertical',
              },
              1300: {
                spaceBetween: 10,
                direction: 'horizontal',
              }
            }
          });
          
          main_slider_settings.thumbs = {
            swiper: this.thumbs,
          };
        }

        this.slider = new Swiper(`#shopify-section-${this.sid} [data-inner-beauty-slider].swiper`, main_slider_settings);
      };
    }

    customElements.define('inner-beauty', InnerBeauty);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-ingredients')) {
  class ProductIngredients extends HTMLElement {
    elements;
    sid;

    constructor(sid) {
      super();

      this.sid = sid;

      this.elements = {
        accordion_items: document.querySelectorAll(`#shopify-section-${this.sid} .product-ingredients__accordion-item`),
        garantee_items: document.querySelectorAll(`#shopify-section-${this.sid} [data-garantee-item]`),
      };
    }

    initAccordion = () => {
      const open_class = 'product-ingredients__accordion-item--open';
      const accordion_items = this.elements.accordion_items;

      for (let i = 0; i < accordion_items.length; i++) {
        accordion_items[i].addEventListener('click', (e) => {
          // Allow clicking so child elements instead of closing accordion item
          if (e.target.closest('.product-ingredients__guarantee') !== null) {
            return;
          }

          const item = e.currentTarget;
          const is_opened = item.classList.contains(open_class);

          for (let j = 0; j < accordion_items.length; j++) {
            accordion_items[j].classList.remove(open_class);
          }

          if (!is_opened) {
            item.classList.toggle(open_class);
          }
        });
      }
    };

    initGuarantees = () => {
      const garantee_items = this.elements.garantee_items;

      for (let i = 0; i < garantee_items.length; i++) {
        garantee_items[i].addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const item = e.currentTarget;

          if (typeof item.dataset.garanteeItem === 'undefined' || typeof item.dataset.garanteeItemModalImage === 'undefined') {
            console.error('Missing data attribute');
            return;
          }

          $(`#${item.dataset.modal}`).modal();
        });
      }
    };
  }

  customElements.define('product-ingredients', ProductIngredients);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-list')) {
    class ProductList extends HTMLElement {
      elements;
      list_collection;
      swiper_product_list;
      selected_group;
      product_limit;
      arrows_position;
      sid;
      has_filters;
      
      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-product-list-slider].swiper`),
          groupTags: document.querySelectorAll(`#shopify-section-${this.sid} .product-list__filters li`),
          changeCardVariant: document.querySelectorAll(`#shopify-section-${this.sid} .card__variant`),
        };
  
        this.product_limit = this.elements.slider.dataset.limit;
        this.arrows_position = this.elements.slider.dataset.arrows;
        this.has_filters = (this.elements.slider.dataset.hasFilters === true || this.elements.slider.dataset.hasFilters === 'true');
        this.list_collection = (this.has_filters == true) ? JSON.parse(document.querySelector(`#shopify-section-${this.sid} [data-product-list-json="${this.sid}"]`).textContent) : [];
        this.swiper_product_list = null;
        this.selected_group = 'shop-all';

        if (this.elements.groupTags.length && this.has_filters == true) {
          Array.from(this.elements.groupTags).forEach((element) => {
            element.addEventListener('click', this.changeGroup.bind(this));
          });
        }
  
        // Dynamically added elements
        if (this.elements.changeCardVariant.length) {
          document.addEventListener('click', this.selectCardVariant.bind(this));
        }
      }
  
      initSlider = () => {
        const slider_settings = {
          a11y: true,
          slidesPerView: 1.5,
          spaceBetween: 20,
          loop: true,
          autoheight: false,
          freeMode: true,
          breakpoints: {
            768: {
              loop: false,
              slidesPerView: 2.5,
              slidesPerGroup: 2.5,
              navigation: {
                enabled: (this.arrows_position !== 'none'),
                nextEl: `#shopify-section-${this.sid} .product-list .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .product-list .swiper-button-prev`,
              },
            },
            990: {
              loop: false,
              slidesPerView: 3,
              slidesPerGroup: 3,
              navigation: {
                enabled: (this.arrows_position !== 'none'),
                nextEl: `#shopify-section-${this.sid} .product-list .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .product-list .swiper-button-prev`,
              },
            },
            1200: {
              loop: false,
              slidesPerView: 4,
              slidesPerGroup: 4,
              navigation: {
                enabled: (this.arrows_position !== 'none'),
                nextEl: `#shopify-section-${this.sid} .product-list .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .product-list .swiper-button-prev`,
              },
            }
          }
        };

        if (this.elements.slider.dataset.scrollbar === 'true') {
          slider_settings.scrollbar = {
            el: `#shopify-section-${this.sid} .swiper-scrollbar`,
            draggable: true,
          };
        }

        this.swiper_product_list = new Swiper(`#shopify-section-${this.sid} [data-product-list-slider].swiper`, slider_settings);
      };
  
      changeGroup = (e) => {
        const item = e.currentTarget;
        const item_group = item.dataset.group

        if (this.selected_group === item_group) {
          return;
        }
  
        this.selected_group = item_group;
  
        Array.from(this.elements.groupTags).forEach((element) => {
          element.classList.remove('active');
        });
  
        item.classList.add('active');
        
        // Find all products assigned to the same group
        let matching_products = [];
        if (item_group === 'shop-all') {
          matching_products = this.list_collection;
        } else {
          matching_products = this.list_collection.filter(product => {
            return product.tags.includes(`group:${item_group}`);
          });
        }
  
        if (matching_products.length > this.product_limit) {
          matching_products = matching_products.slice(0, this.product_limit - 1);
        }
  
        this.swiper_product_list.removeAllSlides();
  
        Array.from(matching_products).forEach((element) => {
          const new_slide = product_list_html.find(element_html => element_html.includes(String(element.id)));
          if (typeof new_slide !== 'undefined') {
            this.swiper_product_list.appendSlide(new_slide);
          }
        });
        
        return matching_products;
      };
  
      selectCardVariant = (e) => {
        const item = e.target.closest('.card__variant');
        if (!item) { return; }
  
        if (item.classList.contains('active')) { return; }
  
        Array.from(item.closest('.card__variants').querySelectorAll('.card__variant')).forEach((element) => {
          element.classList.remove('active');
        });
  
        item.classList.add('active');
  
        const card = item.closest('.card-wrapper');
        card.querySelector('.card__selected-option').innerHTML = item.dataset.variantSize;
        card.querySelector('.card__selected-option').dataset.optionValueHandle = item.dataset.variantSizeHandle;
        card.querySelector('.card__media .media img').src = item.dataset.variantImage;
        card.querySelector('.card__media .media img').removeAttribute('srcset');
  
        if (item.dataset.variantAvailable === true || item.dataset.variantAvailable === 'true') {
          card.querySelector('.quick-add .sold-out-message').classList.add('hidden');
          card.querySelector('.quick-add .quick-add__buy-now').classList.remove('hidden');
          card.querySelector('.quick-add .quick-add__submit').disabled = false;
          card.querySelector('.quick-add .product-variant-id').value = item.dataset.variantId;
        } else {
          card.querySelector('.quick-add .sold-out-message').classList.remove('hidden');
          card.querySelector('.quick-add .quick-add__buy-now').classList.add('hidden');
          card.querySelector('.quick-add .quick-add__submit').disabled = true;
          card.querySelector('.quick-add .product-variant-id').value = '';
        }
      };
    }

    customElements.define('product-list', ProductList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-list')) {
    class ReviewsList extends HTMLElement {
      elements;
      slider;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-reviews-list-slider].swiper`),
        };
      }
  
      initSlider = () => {
        this.slider = new Swiper(`#shopify-section-${this.sid} [data-reviews-list-slider].swiper`, {
          a11y: true,
          slidesPerView: 1.5,
          spaceBetween: 20,
          loop: true,
          autoheight: false,
          freeMode: true,
          scrollbar: {
            el: `#shopify-section-${this.sid} .swiper-scrollbar`,
            draggable: true,
          },
          breakpoints: {
            990: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 80,
              loop: false,
              navigation: {
                enabled: true,
                nextEl: `#shopify-section-${this.sid} .reviews-list .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .reviews-list .swiper-button-prev`,
              },
            }
          }
        });
      };
    }

    customElements.define('reviews-list', ReviewsList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["study-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('study-grid')) {
    class StudyGrid extends HTMLElement {
      elements;
      sid;
      blogTitle;
      blogHandle;
      articles;
      articlesTags;
      filters;
      selectedFilter;
      totalArticlesToShow;

      constructor(sid, blog_title, blog_handle) {
        super();

        this.sid = sid;
        this.blogTitle = blog_title;
        this.blogHandle = blog_handle;
        this.articles = [];
        this.articlesTags = [];
        this.filters = [];
        this.selectedFilter = ''; // '' is 'any'/'all'
        this.totalArticlesToShow = 20;

        this.elements = {
          filterList: document.querySelector(`#shopify-section-${this.sid} [data-study-filter-list]`),
          grid: document.querySelector(`#shopify-section-${this.sid} [data-study-grid-items]`),
        };
      }

      init = async () => {
        this.articles = await this.loadArticles();

        if (this.articles.length === 0 || !this.elements.filterList) {
          return false;
        }

        this.articlesTags = await this.loadTags();

        await this.initFilters();
      };

      populateArticles = () => {
        this.elements.grid.innerHTML = '';

        if (this.articles.length === 0) {
          this.elements.grid.innerHTML = '<p class="study-grid__item-no-results>No results</p>';
          return;
        }

        for (let i = 0; i < this.articles.length; i++) {
          const article = this.articles[i].node;
          const article_element = document.createElement('div');
          article_element.classList.add('study-grid__item');
          article_element.classList.add('scroll-trigger');
          article_element.classList.add('animate--slide-in');

          let article_html = ``;
          if (article.title.length !== 0) {
            article_html += `<h4 class="study-grid__item-title">${article.title}</h4>`;
          }

          if (article.excerptHtml.length !== 0) {
            article_html += `<p class="study-grid__item-excerpt">${article.excerptHtml}</p>`;
          }

          const reference = article.metafields.find((metafield) => {
            return metafield?.namespace === 'haroutine' && metafield?.key === 'reference';
          });

          if (typeof reference !== 'undefined') {
            article_html += `<p class="study-grid__item-reference">${reference.value}</p>`;
          }

          const external_resource = article.metafields.find((metafield) => {
            return metafield?.namespace === 'haroutine' && metafield?.key === 'external_resource';
          });

          if (typeof external_resource === 'undefined') {
            article_html += `<a href="/blogs/${this.blogHandle}/${article.handle}" class="study-grid__item-link" target="_blank">Read the Study</a>`;
          } else {
            article_html += `<a href="${external_resource.value}" class="study-grid__item-link" target="_blank">Read the Study</a>`;
          }

          article_element.innerHTML = article_html;
          this.elements.grid.appendChild(article_element);
        }
      };

      // Extract the filter tags and populate the filters list
      initFilters = () => {
        const extract_filters = [];

        for (let i = 0; i < this.articlesTags.length; i++) {
          const article = this.articlesTags[i].node;
 
          for (let j = 0; j < article.tags.length; j++) {
            const tag = article.tags[j];
            if (tag.includes('filter:')) {
              extract_filters.push(tag.replace('filter:', ''));
            }
          }
        }

        // Unique filters
        this.filters = [...new Set(extract_filters)];

        // Order alphabetically
        this.filters = this.filters.sort((a, b) => a.localeCompare(b));

        // Populate list
        for (let i = 0; i < this.filters.length; i++) {
          const filter = this.filters[i];

          const option = document.createElement('option');
          option.text = filter;
          option.value = filter;
          this.elements.filterList.appendChild(option);
        }

        $(`#shopify-section-${this.sid} [data-study-filter-list]`).selectric({
          arrowButtonMarkup: '<b class="button"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none"><path d="M8.75 13.125L17.5 21.875L26.25 13.125" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></b>',
          disableOnMobile: false,
          nativeOnMobile: false,
          onInit: (element) => {
            this.populateArticles();
          },
          onChange: async (element) => {
            this.selectedFilter = document.querySelector(`#shopify-section-${this.sid} [data-study-grid-filters] .selectric-scroll .selected`).innerText;
            this.articles = await this.loadArticles();
            this.populateArticles();
          },
        }); 
      };
  
      // Send query to Storefront API
      sendQuery = async (query, query_variables = null) => {
        const body = {
          query,
        };

        if (query_variables !== null) {
          body.variables = query_variables;
        }

        const response = await fetch(`https://${window.Shopify.shop}/api/2024-10/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': (window.Shopify.shop.includes('development')) ? '91578dd1fd999fee94019ad21a94eab6' : 'f68687034845eabfdb273423f640012a',
          },
          body: JSON.stringify(body),
        });

        return response;
      };

      // Create query and validate result
      loadArticles = async () => {
        let query_filter = `blog_title:${this.blogTitle}`;
        if (this.selectedFilter !== '' && this.selectedFilter.trim() !== '' && this.selectedFilter !== 'Any') {
          const cleanFilter = this.selectedFilter.trim().replace(/"/g, '\\"');
          query_filter += ` AND tag:"filter:${cleanFilter}"`;
        }

        const query = `
          query GetFilteredArticles($queryFilter: String!) {
            articles(first: ${this.totalArticlesToShow}, query: $queryFilter) {
              edges {
                node {
                  id
                  handle
                  title
                  tags
                  excerptHtml
                  metafields(
                    identifiers: [
                      {namespace: "haroutine", key: "category"},
                      {namespace: "haroutine", key: "reference"},
                      {namespace: "haroutine", key: "external_resource"}
                    ]
                  ) {
                    key
                    namespace
                    value
                    id
                  }
                }
              }
            }
          }
        `;

        const variables = {
          queryFilter: query_filter
        };
        
        const response = await this.sendQuery(query, variables);

        if (!response.ok) {
          // throw new Error(`HTTP error ${response.status}`);
          console.log(`HTTP error ${response.status}`);
          return [];
        }

        const response_json = await response.json();

        if (typeof response_json.errors !== 'undefined') {
          console.log('[Storefront API] Error in response:', response_json.errors);
          return [];
        }

        if (typeof response_json.data === 'undefined') {
          console.log('[Storefront API] No data 1', response_json);
          return [];
        }

        if (typeof response_json.data === 'undefined' || typeof response_json.data.articles === 'undefined' || typeof response_json.data.articles.edges === 'undefined') {
          console.log('[Storefront API] No data 2', response_json);
          return [];
        }

        return response_json.data.articles.edges;
      };
      
      loadTags = async () => {
        const query = `
          query articlesTags {
            articles(first: 100) {
              edges {
                node {
                  tags
                }
              }
            }
          }
        `;

        const response = await this.sendQuery(query);

        if (!response.ok) {
          // throw new Error(`HTTP error ${response.status}`);
          console.log(`HTTP error ${response.status}`);
          return [];
        }

        const response_json = await response.json();

        if (typeof response_json.errors !== 'undefined') {
          console.log('[Storefront API] Error in response:', response_json.errors);
          return [];
        }

        if (typeof response_json.data === 'undefined') {
          console.log('[Storefront API] No data 1', response_json);
          return [];
        }

        if (typeof response_json.data === 'undefined' || typeof response_json.data.articles === 'undefined' || typeof response_json.data.articles.edges === 'undefined') {
          console.log('[Storefront API] No data 2', response_json);
          return [];
        }

        return response_json.data.articles.edges;
      };
    }

    customElements.define('study-grid', StudyGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
